import React, { useRef, useState } from 'react';
import { ExpandMore } from '@mui/icons-material';

import Menu from '../Menu/Menu';
import MappedLabel from '../MappedLabel/MappedLabel';

const style = {
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  cursor: 'pointer',
  padding: '0 16px',
};
const subStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '100%',
  cursor: 'pointer',
  padding: '5px 16px',
  fontSize: 15,
};

const HIDE_DELAY = 100;

function HoverDropdownButton({
  customWidth,
  children,
  label,
  className,
  popoverTopOffset,
  popoverLeftOffset,
  placement,
  submenu = false,
  mappedLabel = null,
  modal = false,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const pointerOverDropdown = useRef(false);
  const pointerOverTarget = useRef(false);
  const anchorEl = useRef(null);

  const handleHover = (event) => {
    const target = event.currentTarget;

    pointerOverTarget.current = true;
    setTimeout(() => {
      if (pointerOverTarget.current) {
        setIsOpen(true);
        pointerOverTarget.current = true;
        anchorEl.current = target;
      }
    }, HIDE_DELAY);
  };

  const handleRequestClose = () => {
    pointerOverTarget.current = false;
    setTimeout(() => {
      if (!pointerOverDropdown.current) {
        setIsOpen(false);
      }
    }, HIDE_DELAY);
  };

  const handlePopoverHover = () => {
    pointerOverDropdown.current = true;
  };

  const handleRequestPopoverClose = () => {
    pointerOverDropdown.current = false;
    setTimeout(() => {
      if (!pointerOverTarget.current) {
        setIsOpen(false);
      }
    }, HIDE_DELAY);
  };

  const customWidthEl = customWidth ? { width: customWidth } : {};

  return (
    <>
      <div className={className} style={submenu ? subStyle : style} onMouseEnter={handleHover} onMouseLeave={handleRequestClose}>
        {mappedLabel ? <MappedLabel reserve={label}>{mappedLabel}</MappedLabel> : label}
        <ExpandMore style={{ rotate: submenu ? '-90deg' : 0 }} />
      </div>
      <Menu
        open={isOpen}
        anchorEl={anchorEl.current ? anchorEl.current : null}
        style={{ marginTop: popoverTopOffset, marginLeft: popoverLeftOffset, ...customWidthEl }}
        placement={placement}
        onListMouseEnter={handlePopoverHover}
        onListMouseLeave={handleRequestPopoverClose}
        modal={modal}
      >
        {children}
      </Menu>
    </>
  );
}

export default HoverDropdownButton;
